export const createUserInitialValues = {
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  afm: '',
  role_id: null,
  administrative_unit_id: null,
  is_enabled: false,
  roles: []
};
